import App from './containers/App';
import { appRoutes } from './shared/constants';

const errorLoading = (error) => {
  console.error('Dynamic page loading failed', error); // eslint-disable-line no-console
};

const loadComponent = cb => (componentModule) => {
  cb(null, componentModule.default);
};

export default {
  component: App,
  name: 'app',
  path: '/',
  indexRoute: { onEnter: (_, replace) => replace(`/${appRoutes.login}`) },
  childRoutes: [
    {
      path: appRoutes.clients.index,
      name: 'clients',
      pageTitle: 'Clientes - Registros',
      getComponent(location, cb) {
        import('./containers/ClientsAdvancedSearch')
          .then(loadComponent(cb))
          .catch(errorLoading);
      }
    },
    {
      path: appRoutes.dashboard.index,
      name: 'dashboard',
      pageTitle: 'Dashboard - Inicio',
      indexRoute: {
        getComponent(location, cb) {
          import('./containers/DashboardHome')
            .then(loadComponent(cb))
            .catch(errorLoading);
        }
      },
      getComponent(location, cb) {
        import('./containers/Dashboard')
          .then(loadComponent(cb))
          .catch(errorLoading);
      },
      childRoutes: [
        {
          path: appRoutes.dashboard.carriers,
          name: 'dashboardCarriers',
          pageTitle: 'Dashboard - Transportistas',
          getComponent(location, cb) {
            import('./containers/DashboardCarriers')
              .then(loadComponent(cb))
              .catch(errorLoading);
          }
        },
        {
          path: appRoutes.dashboard.clients,
          name: 'dashboardClients',
          pageTitle: 'Dashboard - Clientes',
          getComponent(location, cb) {
            import('./containers/DashboardClients')
              .then(loadComponent(cb))
              .catch(errorLoading);
          }
        },
        {
          path: appRoutes.dashboard.depots,
          name: 'dashboardDepots',
          pageTitle: 'Dashboard - Predios',
          getComponent(location, cb) {
            import('./containers/DashboardDepots')
              .then(loadComponent(cb))
              .catch(errorLoading);
          }
        },
        {
          path: appRoutes.dashboard.editableFields,
          name: 'dashboardEditableFields',
          pageTitle: 'Dashboard - Campos Editables',
          getComponent(location, cb) {
            import('./containers/DashboardEditableFields')
              .then(loadComponent(cb))
              .catch(errorLoading);
          }
        },
        {
          path: appRoutes.dashboard.notifications,
          name: 'dashboardNotifications',
          pageTitle: 'Dashboard - Notificaciones',
          getComponent(location, cb) {
            import('./containers/DashboardNotifications')
              .then(loadComponent(cb))
              .catch(errorLoading);
          }
        },
        {
          path: appRoutes.dashboard.pilots,
          name: 'dashboardPilots',
          pageTitle: 'Dashboard - Pilotos',
          getComponent(location, cb) {
            import('./containers/DashboardPilots')
              .then(loadComponent(cb))
              .catch(errorLoading);
          }
        },
        {
          path: appRoutes.dashboard.templates,
          name: 'dashboardTemplates',
          pageTitle: 'Dashboard - Plantillas',
          getComponent(location, cb) {
            import('./containers/DashboardTemplates')
              .then(loadComponent(cb))
              .catch(errorLoading);
          }
        },
        {
          path: appRoutes.dashboard.advancedSearch,
          name: 'dashboardAdvancedSearch',
          pageTitle: 'Dashboard - Búsqueda Avanzada',
          getComponent(location, cb) {
            import('./containers/DashboardAdvancedSearch')
              .then(loadComponent(cb))
              .catch(errorLoading);
          }
        },
        {
          path: appRoutes.dashboard.containersDamage,
          name: 'dashboardContainersDamage',
          pageTitle: 'Dashboard - Daños de Contenedores',
          getComponent(location, cb) {
            import('./containers/DashboardContainersDamage')
              .then(loadComponent(cb))
              .catch(errorLoading);
          }
        },
        {
          path: appRoutes.dashboard.operations,
          name: 'dashboardOperations',
          pageTitle: 'Dashboard - Bitácora de Operaciones',
          getComponent(location, cb) {
            import('./containers/DashboardOperations')
              .then(loadComponent(cb))
              .catch(errorLoading);
          }
        },
        {
          path: appRoutes.dashboard.users,
          name: 'dashboardUsers',
          pageTitle: 'Dashboard - Usuarios',
          getComponent(location, cb) {
            import('./containers/DashboardUsers')
              .then(loadComponent(cb))
              .catch(errorLoading);
          }
        },
        {
          path: appRoutes.dashboard.massUpload,
          name: 'dashboardMassUpload',
          pageTitle: 'Dashboard - Carga de Registros',
          getComponent(location, cb) {
            import('./containers/DashboardMassUpload')
              .then(loadComponent(cb))
              .catch(errorLoading);
          }
        },
        {
          path: appRoutes.dashboard.advancedSearchClient,
          name: 'dashboardAdvancedSearchClient',
          pageTitle: 'Dashboard - Búsqueda Avanzada Cliente',
          getComponent(location, cb) {
            import('./containers/ClientsAdvancedSearch')
              .then(loadComponent(cb))
              .catch(errorLoading);
          }
        }
      ]
    },
    {
      path: appRoutes.login,
      name: 'login',
      pageTitle: 'Login',
      getComponent(location, cb) {
        import('./containers/LoginPage')
          .then(loadComponent(cb))
          .catch(errorLoading);
      }
    },
    {
      path: appRoutes.technicians.index,
      name: 'technicians',
      pageTitle: 'Técnicos - Formulario',
      getComponent(location, cb) {
        import('./containers/TechniciansReportForm')
          .then(loadComponent(cb))
          .catch(errorLoading);
      }
    },
    {
      path: '*',
      name: 'notFound',
      getComponent(location, cb) {
        import('./components/NotFoundPage')
          .then(loadComponent(cb))
          .catch(errorLoading);
      }
    }
  ]
};



// WEBPACK FOOTER //
// ./src/routes.js